import { Fragment, useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import { Stack } from "../FormControls/Stack";

import { Header } from "./Header";
import { ScreenRouter } from "./ScreenRouter";

// CHANGE WHEN IMPLEMENTING REDUX
import { DEFAULTS } from "../../styles/defaults";
import { useCallback } from "react";

export const KitQRForm = () => {

    const [c, setCoockie, removeCookie] = useCookies();
    const [dimensions, setDimensions] = useState({ height: window.innerHeight, width: window.innerWidth });
    const handleWindowResize = () => setDimensions({ height: window.innerHeight, width: window.innerWidth });

    const clearCoockies = useCallback(() => {
        const url = new URLSearchParams((new URL(window.location.href)).search);
        setCoockie("Store", url.get("Store"));
        removeCookie("PHPSESSID");
        removeCookie("coincaex");
        removeCookie("token");
        removeCookie("type");
        removeCookie("u");
    }, [removeCookie, setCoockie]);

    useEffect(() => {
        clearCoockies();
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [clearCoockies]);

    return (
        <Fragment>
            <div style={{ width: "96%", margin: "0 2%", display: "flex", justifyContent: "center", ...DEFAULTS, height: (dimensions.height * 0.95) }}>
                <Stack
                    flex={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                    style={{ maxWidth: "500px", width: "100%" }}
                >

                    <Header />

                    <ScreenRouter key={0} />

                </Stack>
            </div>
        </Fragment >
    )
};